"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    personalDataTitle: {
        id: 'user.personalDataTitle',
        defaultMessage: 'Personal data',
        description: 'Personal data page title',
    },
    language: {
        id: 'user.language',
        defaultMessage: 'Language',
        description: 'User language',
    },
    editLanguage: {
        id: 'user.editLanguage',
        defaultMessage: 'Edit language',
        description: 'User edit language',
    },
    marketingChannelWillBeLost: {
        id: 'user.marketingChannelWillBeLost',
        defaultMessage: 'Marketing {count, plural, one {Channel} other {Channels}} will be lost',
        description: 'User marketing channel(s) will be lost',
    },
    marketingChannelDeleteOfficePhoneNumber: {
        id: 'user.marketingChannelDeleteOfficePhoneNumber',
        defaultMessage: "When deleting your office phone number, you won't receive marketing information via phone any more. Do you really want to delete your data?",
        description: 'User marketing channel delete office phone number',
    },
    marketingChannelDeleteMobilePhoneNumber: {
        id: 'user.marketingChannelDeleteMobilePhoneNumber',
        defaultMessage: "When deleting your mobile phone number, you won't receive marketing information via SMS or messaging service any more. Do you really want to delete your data?",
        description: 'User marketing channel delete mobile phone number',
    },
    marketingChannelDeleteBothPhoneNumbers: {
        id: 'user.marketingChannelDeleteBothPhoneNumbers',
        defaultMessage: "When deleting your phone numbers, you won't receive marketing information via phone or messaging service. Do you want to delete your data?",
        description: 'User marketing channel delete both phone numbers',
    },
    marketingChannelDeleteAddress: {
        id: 'user.marketingChannelDeleteAddress',
        defaultMessage: "When deleting your address, you won't receive marketing information via letter any more. Do you really want to delete your data?",
        description: 'User marketing channel delete address',
    },
    profilePicture: {
        id: 'user.profilePicture',
        defaultMessage: 'Profile Picture',
        description: 'Profile picture label',
    },
    uploadImage: {
        id: 'user.uploadImage',
        defaultMessage: 'Upload Image',
        description: 'Upload image button text',
    },
    cropImage: {
        id: 'user.cropImage',
        defaultMessage: 'Crop image',
        description: 'Crop image label',
    },
    profilePictureDescription: {
        id: 'user.profilePictureDescription',
        defaultMessage: 'Manage your profile photo to gain a personalized profile tone and the assurance that you are logged into your account.',
        description: 'Profile picture management description',
    },
    removeProfilePicture: {
        id: 'user.removeProfilePicture',
        defaultMessage: 'Remove profile picture',
        description: 'Remove profile picture button text',
    },
    removeProfilePictureConfirmation: {
        id: 'user.removeProfilePictureConfirmation',
        defaultMessage: 'Are you sure you want to remove your current profile picture?',
        description: 'Confirmation message for removing profile picture',
    },
});
exports.default = messages;
